import React from "react";
import { ArrowLeft, CalendarDays, UserRound } from "lucide-react";
import { Link } from "react-router-dom";
import { apiAsset } from "../../../commons/inFormTypes";

const plainText = (value = "") => value.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

const SingleBlog = ({ data }) => {
  const category = data?.articleCategories?.[0]?.category?.categoryName;
  const author = [data?.user?.name, data?.user?.family].filter(Boolean).join(" ");
  const date = data?.datePublished ? new Date(data.datePublished).toLocaleDateString("fa-IR", { year: "numeric", month: "long", day: "numeric" }) : "";
  const summary = plainText(data?.newsBox || data?.secondTitle || "");

  return (
    <article className="blog-card">
      <Link className="blog-card__media" to={`/blog-details/${data?.slug}`}>
        {data?.mainPicture ? <img src={`${apiAsset}${data.mainPicture}`} alt={data?.articleTittle || "تصویر مقاله"} loading="lazy" onError={(event) => { event.currentTarget.style.display = "none"; }} /> : <div className="blog-card__placeholder" />}
        {category && <span>{category}</span>}
      </Link>
      <div className="blog-card__body">
        <div className="blog-card__meta">{date && <span><CalendarDays size={14} />{date}</span>}{author && <span><UserRound size={14} />{author}</span>}</div>
        <h3><Link to={`/blog-details/${data?.slug}`}>{data?.articleTittle || "بدون عنوان"}</Link></h3>
        <p>{summary.length > 145 ? `${summary.slice(0, 145)}...` : summary}</p>
        <Link className="blog-card__more" to={`/blog-details/${data?.slug}`}>ادامه مطلب <ArrowLeft size={16} /></Link>
      </div>
    </article>
  );
};

export default SingleBlog;
